module.exports = __webpack_public_path__ + "img/LTS_ADP.96d92a09.gif";